/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import NotificationDropdown from './NotificationDropdown.js'
import UserDropdown from './UserDropdown.js'
import ModalCentro from "../../components/Modal/Modal Centro";
import { Button } from "react-bootstrap";

import { Nav } from "react-bootstrap";

import "./Top.css";
import DateAndHour from "./DateAndHour.js";


function Top({ color, image, routes }) {
  const [showModal, setShowModal] = useState(false);

  const location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  // Función para manejar el cierre del modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="top" data-image={image} data-color={color}>
      <div
        className="sidebar-background"
        style={{
          backgroundImage: "url(" + image + ")",
        }}
      />
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-start">
          <a
            href="https://constecoin.com"
            className="simple-text logo-mini mx-1"
          >
            <div>
              <img className="logo-img"
                src={require("../../assets/img/logo_constecoin.png").default}
                alt="..."
              />
            </div>
          </a>
          {/* <a className="simple-text" href="http://www.creative-tim.com">
            CONSTECOIN
          </a> */}
          <div className="notification-top">
            <DateAndHour />
            <NotificationDropdown />
            <UserDropdown onClick={handleOpenModal} />
          </div>

        </div>
        <ModalCentro isOpen={showModal} toggle={handleCloseModal}>
          <h4>MANUALES</h4>
          <Button style={{ position: "absolute", top: "10px", right: "10px" }} onClick={handleCloseModal}>
            X
          </Button>
          <div>
            {/* Aquí puedes colocar más información sobre el manual */}
            <p>Haz clic en cada enlace para abrir y descargar el manual</p>
            <ul>
              <li>
                <a href="https://aiot.constecoin.com/repositorio/epconst/ManualPlataforma.pdf" target="_blank" rel="noopener noreferrer">
                  Manual Plataforma IoT
                </a>
              </li>
              <li>
                <a href="https://aiot.constecoin.com/repositorio/epconst/ManualAPP.pdf" target="_blank" rel="noopener noreferrer">
                  Manual APP Alerta Global
                </a>
              </li>
              <li>
                <a href="https://aiot.constecoin.com/repositorio/epconst/ManualAlarma.pdf" target="_blank" rel="noopener noreferrer">
                  Manual de usuario alarma comunitaria
                </a>
              </li>
              <li>
                <a href="https://aiot.constecoin.com/repositorio/epconst/ManualMantenimiento.pdf" target="_blank" rel="noopener noreferrer">
                  Manual mantenimiento alarma comunitaria
                </a>
              </li>
              <li>
                <a href="https://aiot.constecoin.com/repositorio/epconst/DiagramaFuncionamiento.pdf" target="_blank" rel="noopener noreferrer">
                  Diagrama de funcionamiento panel de control de alarma comunitaria
                </a>
              </li>
            </ul>
          </div>
        </ModalCentro>
        {/* <Nav>
          {routes.map((prop, key) => {
            if (!prop.redirect)
              return (
                <li
                  // className={
                  //   prop.upgrade
                  //     ? "active active-pro"
                  //     : activeRoute(prop.layout + prop.path)
                  // }
                  // key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            return null;
          })}
        </Nav> */}


      </div>
    </div>
  );
}

// max-width: 200px;



export default Top;
